export const GroupCode = {
  Central: 'C',
  Hospital: 'H',
  Polyclinic: 'P',
  StudentHealthCentre: 'HPB',
} as const;
export type GroupCodeType = (typeof GroupCode)[keyof typeof GroupCode];
